import React, {useEffect, useState} from 'react';
import './styles/main-league-center.scss';
import LeagueCenter from './widgets/LeagueCenter';

/**
 * @deprecated duplicate IProvider for types.ts
 */
export interface IProvider {
  id: number;
  slug: string;
}

interface IProps {
  elem: Element;
}

const LeagueCenterIndex: React.FC<IProps> = ({elem}) => {
  const [widgetId, setWidgetId] = useState<number|null>(null)
  const [listRangeFrom, setListRangeFrom] = useState<number|null>(null)
  const [listRangeTo, setListRangeTo] = useState<number|null>(null)
  const [competitionId, setCompetitionId] = useState<number|null>(null)
  const [marketTypeIds, setMarketTypeIds] = useState<number[]|null>(null)

  useEffect(() => {
    // loadWidgetStyleFile('betting-calculator-styles.css');

    const div: HTMLDivElement = elem as HTMLDivElement
    div.dataset.id && setWidgetId(parseInt(div.dataset.id))
    div.dataset.listRangeFrom && setListRangeFrom(parseInt(div.dataset.listRangeFrom))
    div.dataset.listRangeTo && setListRangeTo(parseInt(div.dataset.listRangeTo))
    div.dataset.marketTypeIds && setMarketTypeIds(div.dataset.marketTypeIds.split(',').map((marketTypeId: string) => parseInt(marketTypeId.trim())))
    div.dataset.competitionId && setCompetitionId(parseInt(div.dataset.competitionId))
  }, [elem])

  return (
    <>
      {widgetId && (
        <LeagueCenter
          widgetID={widgetId}
          competitionId={competitionId}
          listRangeFrom={listRangeFrom}
          listRangeTo={listRangeTo}
          marketTypeIds={marketTypeIds}
          elem={elem}
          hasCache={elem.hasChildNodes()}
        />
      )}
    </>
  )
}

export default LeagueCenterIndex;
